<template>
  <div class="base-table-lite" :class="{ 'show-pagination': showPagination }">
    <div class="table-wrap">
      <el-table
        ref="table"
        v-bind="$attrs"
        v-on="$listeners"
        :data="rows"
        v-loading="loading"
      >
        <el-table-column
          v-for="(col, index) in columns"
          :key="index"
          v-bind="col.bind"
          show-overflow-tooltip
        >
          <template v-if="col.header && col.header.component" #header="scope">
            <component
              :is="$getComponent(col.header.component, scope)"
              v-bind="col.header.bind"
              v-on="col.header.on"
              :scope="scope"
            ></component>
          </template>
          <template
            v-if="col.default && col.default.component"
            #default="scope"
          >
            <component
              :is="$getComponent(col.default.component, scope)"
              v-bind="col.default.bind"
              v-on="col.default.on"
              :scope="scope"
            ></component>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div v-if="showPagination" class="pagination">
      <el-pagination
        ref="pagination"
        style="text-align: right"
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page="query.PageIndex"
        :page-sizes="pageSizes"
        :page-size="query.PageSize"
        :layout="paginationLayout"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: 'base-table-lite',
  props: {
    basepath: Object,
    url: String,
    columns: Array,
    initSearch: {
      //初始化后执行查询操作
      type: Boolean,
      default: true,
    },
    fixSearchData: Function,
    sendJson: Boolean,
    paginationLayout: {
      type: String,
      default: 'total, sizes, prev, jumper, next',
    },
    showPagination: {
      type: Boolean,
      default: true,
    },
    responseHandler: Function,
    pageSizes: {
      type: Array,
      default() {
        return [10, 20, 30, 40, 50, 60, 70, 80, 90, 100]
      },
    },
    query: {
      type: Object,
      default() {
        return {
          PageIndex: 1, //PageIndex 一定要大写
          PageSize: 20, //PageSize 一定要大写
        }
      },
    },
  },
  created() {
    if (!this.query.PageIndex) {
      this.$set(this.query, 'PageIndex', 1)
    }
    if (!this.query.PageSize) {
      this.$set(this.query, 'PageSize', 30)
    }

    if (this.initSearch) {
      this.refreshData()
    }
  },
  data() {
    return {
      loading: false,
      rows: [],
      total: 0,
      searchData: {},
    }
  },
  computed: {
    table() {
      return this.$refs.table
    },
  },
  methods: {
    getTableWrapStyle() {
      var style = {}
      if (this.basepath) {
        style.height = 'calc(100% - 14px)'
      }
      return style
    },
    getContentWrapStyle() {
      var style = {}
      if (!this.showPagination) {
        style.paddingBottom = '10px'
      }
      return style
    },
    defaultCell(scope) {
      if (scope.column.property.indexOf('.') > -1) {
        var arr = scope.column.property.split('.')
        var val = scope.row
        for (var i = 0; i < arr.length; i++) {
          val = val[arr[i]]
          if (val == undefined) return ''
        }
        return val
      }
      return scope.row[scope.column.property]
    },
    /*查询按钮事件*/
    tableSearch() {
      this.query.PageIndex = 1
      this.refreshData()
    },

    /*获取查询参数*/
    getSearchData() {
      var data = Object.assign({}, this.searchData, this.query)
      if (typeof this.fixSearchData === 'function') {
        data = this.fixSearchData(data)
      }
      return data
    },
    /*刷新table数据*/
    refreshData() {
      setTimeout(() => {
        //延迟调用，因为getSearchData()的mvvm需要一段执行时间才能更新完
        var data = this.getSearchData()
        this[this.sendJson ? '$postObj' : '$post'](
          this.url,
          data,
          (data, headers) => {
            this.loading = true
          },
          (data) => {
            this.loading = false
          }
        )
          .then((resp) => {
            if (typeof this.responseHandler == 'function') {
              this.setTableData(this.responseHandler(resp))
            } else {
              if (resp.data.code == 0) {
                this.setTableData({
                  rows: resp.data.data.Data || [],
                  total: resp.data.data.Total || 0,
                })
              } else {
                this.$message(resp.data.msg || '服务端返回数据异常')
                console.error(resp)
              }
            }
          })
          .catch((error) => {
            // 请求失败处理
            this.loading = false
            this.$message('请求发生错误！')
            console.error(error)
          })
      }, 50)
    },
    setTableData(data) {
      if (data) {
        this.rows = data.rows || []
        this.total = data.total || 0
        this.$nextTick(() => {
          this.$emit('loaded')
        })
      }
    },
    sizeChange(PageSize) {
      this.query.PageIndex = 1
      this.query.PageSize = PageSize
      this.refreshData()
    },
    currentChange(PageIndex) {
      this.query.PageIndex = PageIndex
      this.refreshData()
    },
    loadRows(rows) {
      if (Array.isArray(rows)) {
        this.rows = rows
        this.total = rows.length
      }
    },
    delRow(row) {
      var index = this.rows.indexOf(row)
      if (index > -1) this.rows.splice(index, 1)
    },
    addRow(row) {
      this.rows.unshift(row)
    },
    updRow(oldRow, newRow, overrideAll = true) {
      for (var key in oldRow) {
        this.$set(oldRow, key, newRow[key])
      }
    },
  },
}
</script>

<style lang="less">
.base-table-lite {
  position: relative;
  box-sizing: border-box;
  background-color: #fff;
  &.show-pagination {
    padding-bottom: 52px;
  }
  .table-wrap {
    height: 100%;
  }

  .pagination {
    position: absolute;
    left: 10px;
    right: 10px;
    bottom: 10px;
  }
  .el-table th.el-table__cell > .cell {
    word-break: inherit;
  }
}
</style>
